<template>
  <div class="wrapp-gifts">
    <ul>
      <li v-for="gift in giftCards" :key="gift.cardNumber">
        <gift-tile :gift="gift" :selected="giftCardSelected" @clicked="submitGiftOnCart" />
      </li>
    </ul>
    <div class="message" v-show="giftCardSelected.length && totalAmount > 0">
      {{ $t('gift.pay-remaining-using-another-method', { amount: totalAmountWithCurrency })}}
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/helpers'
import GiftTile from 'theme/components/Checkout/PaymentMethods/Gifts/GiftTile/GiftTile'

export default {
  name: 'GiftPay',
  data () {
    return {
      selected: []
    }
  },
  computed: {
    totalAmount () {
      return this.$store.getters['cart/totalAmount']
    },
    totalAmountWithCurrency () {
      return this.$options.filters.price(this.totalAmount, this.$store)
    },
    giftCards () {
      return this.$store.getters['cart/getGiftCards']
    },
    giftCardSelected () {
      return this.$store.getters['cart/getActiveGiftCards']
    },
    canSelectMore () {
      return this.giftCardSelected.length <= this.giftCards.length || this.totalAmount > 0
    }
  },
  methods: {
    submitGiftOnCart ($event) {
      this.$store.commit('ui/showLoader')
      return this.$store.dispatch('checkout/setGiftCard', { cardCode: $event.cardNumber, cardAmount: $event.cardAmount, paymentInstrumentId: $event.paymentInstrumentId, add: $event.add })
        .then(() => {
          EventBus.$emit('checkout:updResume')
          // this.$emit('updated')
        })
        .finally(() => {
          this.$store.commit('ui/hideLoader')
        })
    }
  },
  components: {
    GiftTile
  }
}
</script>
